import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../BaseDatabaseService';

@Injectable({
  providedIn: 'root'
})
export class FormsService extends BaseDatabaseService{

  private collectionName = 'forms';

  constructor() {
    super();
  }

  createForms(formUrl, race, formData, payMethod) {
    formData = formData.map( item => Object.assign({}, item) );
    const obj = {
      url: formUrl,
      race: this.db.collection('races').doc(race),
      formItems: formData,
      payMethod: payMethod
    };
    console.dir(obj);
    return this.db.collection(this.collectionName).doc(formUrl).set(obj);
  }

  getOneForm(key) {
    return this.db.collection(this.collectionName).doc(key).get();
  }

  deleteForm(id){
    return this.db.collection(this.collectionName).doc(id).delete();
  }

  getForms() {
    return this.db.collection(this.collectionName).get();
  }

  getFormByRace(raceId) {
    return this.db.collection(this.collectionName).orderBy('race').startAt('/races/' + raceId).get();
  }

}
